import { render, staticRenderFns } from "./VendorTable.vue?vue&type=template&id=de9c3924"
import script from "./VendorTable.vue?vue&type=script&lang=js"
export * from "./VendorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports